import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import MaskedInput from 'react-text-mask';
import Bunexe_service from './../../Bunexe_service';
import Button from 'react-bootstrap/Button';
import { format, addDays } from 'date-fns';
import { FaForward } from 'react-icons/fa';
import ReactTooltip from 'react-tooltip';
import { toast } from 'react-toastify';
// import Bunexe_service from '../../Bunexe_service';

const EmailTelCandidat = ({
  setCurrentform,
  currentform,
  email,
  setEmail,
  tel,
  setTel,
}) => {
  let url_ = Bunexe_service.url;
  const [telExiste, setTelExist] = useState(false);
  const [doneloaded, setDoneloaded] = useState(true);

  const TelExisteDeja = async (tel) => {
    // console.log(`#######   ${tel.trim()}   ######`);
    if (tel.trim().length < 15)
      toast.error(
        'Désolé, Ce numero de Telephone est Obligatoire et doit etre au format (509) xxxx-xxxx',
        {
          position: toast.POSITION.TOP_RIGHT,
        }
      );
    else {
      setDoneloaded(false);
      //setTelExist(true);
      try {
        fetch(url_ + `/recherche/perm_en_ligne/verif_tel/${tel}`)
          .then((response) => response.json())
          .then((data) => {
            if (data.length > 0) {
              setTelExist(true);
              toast.error(
                'Désolé, Ce numero de Telephone est deja enregistré dans la base de données',
                {
                  position: toast.POSITION.TOP_RIGHT,
                }
              );
            } else {
              setTelExist(false);
              setTel(tel);
              setCurrentform(currentform + 1);
            }
            setDoneloaded(true);
          })
          .catch((err) => console.log(err));
      } catch (error) {
        console.log(error);
      }
    }
  };

  const verifTel = async () => {
    if (tel.replace('_', '').trim().length < 15)
      toast.error(
        'Désolé, Ce numero de Telephone est Obligatoire et doit etre au format (509) xxxx-xxxx',
        {
          position: toast.POSITION.TOP_RIGHT,
        }
      );
    else if (telExiste)
      toast.error(
        'Désolé, Ce numero de Telephone est deja enregistré dans la base de données',
        {
          position: toast.POSITION.TOP_RIGHT,
        }
      );
    else {
      if (tel.length >= 15) setCurrentform(currentform + 1);
      else
        toast.error(
          'Désolé, Ce numero de Telephone est Obligatoire et doit etre au format (509) xxxx-xxxx',
          {
            position: toast.POSITION.TOP_RIGHT,
          }
        );
    }
  };
  const handleSubmit = async () => {
    {
      await TelExisteDeja(tel.replace('_', '').trim());
    }
  };

  return (
    <div className='row'>
      <div className='col-sm-12 col-md-8 offset-md-2 col-lg-8 offset-lg-2'>
        <div className='card mb-3'>
          <div className='card-header'>
            <h2 className='display-5 text-center'>Tel et Email du Candidat</h2>
          </div>
          <div className='card-body'>
            <div className='row container d-flex justify-content-center'>
              <Form>
                <Form.Row className=' p-3 mb-4'>
                  <div className='col-sm-12 col-md-6 col-lg-6'>
                    <div className='form-group'>
                      <label>* Telephone </label>
                      {telExiste}
                      <MaskedInput
                        mask={[
                          '(',
                          '5',
                          '0',
                          '9',
                          ')',
                          ' ',
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                          '-',
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                        ]}
                        className='form-control'
                        placeholder='(509)'
                        value={tel}
                        name='tel'
                        onFocus={(e) => {
                          // setInfoPh([]);
                        }}
                        onChange={(e) => {
                          setTel(e.target.value);
                        }}
                        // onBlur={(e) => {
                        //   TelExisteDeja(e.target.value.replace('_', '').trim());
                        //   // setTel(e.target.value);
                        // }}
                        guide={true}
                      />
                    </div>
                  </div>

                  <div className='col-sm-12 col-md-6 col-lg-6'>
                    <div className='form-group'>
                      <label htmlFor='exampleInputEmail1'>Email address</label>
                      <input
                        type='email'
                        className='form-control'
                        id='exampleInputEmail1'
                        aria-describedby='emailHelp'
                        placeholder='Email'
                        name='email'
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        onBlur={(e) => setEmail(e.target.value)}
                      />
                    </div>
                  </div>

                  <Button
                    className='btn-block'
                    style={{ marginTop: '20px', marginBottom: '10px' }}
                    variant='primary'
                    onClick={(e) => handleSubmit()}
                  >
                    Continuer
                  </Button>
                </Form.Row>
              </Form>
            </div>
          </div>

          <div className='card-footer'>
            {/*            
            <div className='d-flex justify-content-between'>
              <button
                className='btn btn-small btn-info'
                onClick={(e) => setCurrentform(currentform - 1)}
              >
                An&&No. Ordre && Session
              </button>
              <button
                className='btn btn-small btn-info'
                onClick={(e) => setCurrentform(currentform + 1)}
              >
                Resumé
              </button>
            </div>
           */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailTelCandidat;
